import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { parseISO, differenceInDays, addDays, isSameDay, format } from 'date-fns';
import _ from 'lodash';

import { apiCallBegan } from './api';
import config from '../config/config';

const apiToken = process.env.REACT_APP_API_TOKEN;

	
const slice = createSlice({
  name: 'meetings',
  initialState: {
    list: [],
  },
  reducers: {

    meetingsReceived: (meetings, action) => {
      // meetings.list = action.payload.data;
      meetings.list = [];

      action.payload.data.forEach(m => {
        const startDate = parseISO(m.start)
        const endDate = parseISO(m.end)
        const daysDiff = differenceInDays(endDate, startDate) + 1
        
        let weekends = []
        _.forEach(m.weekends, function (w) {
          weekends.push(parseISO(w.date))
        })

        const days = _.range(
          0,
          daysDiff,
          1
          ).map(daysNum => {
            const currentDay = addDays(startDate, daysNum);
            return {date: format(currentDay,'dd.MM.yyyy'), isWeekend: weekends.filter(w => isSameDay(w,currentDay)).length > 0 }
          })

        meetings.list.push({
          id: m.id,
          name: m.name,
          days
        });
      });
    },

  

  }
});

const { meetingsReceived } = slice.actions;
export default slice.reducer;

// Action Creators

export const loadMeetings = () => async (dispatch, getState) => {
  const eventId = config.eventId
  return await dispatch(
    apiCallBegan({
      url: `/api/event/${eventId}/meetings?secret_key=${apiToken}`,
      onSuccess: meetingsReceived.type,
      actionName: 'loadMeetings',
    })
  );
};


  

// Selectors

export const getMeetingsSelector = createSelector(
  state => state.entities.meetings.list,
  meetings => meetings
);


// Helpers methods

